import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Utils } from '../../../../core/services/utils.service';
import { SessionService } from '../../../../core/services/session.service';

const ITEMS_PER_CHUNK = 15;

@Component({
    selector: 'app-filter-library-modal',
    templateUrl: './filter-library.component.html',
    styleUrls: ['./filter-library.component.scss'],
    standalone: false
})
export class FilterLibraryModalComponent implements OnInit {
	loader: boolean = false;

	plans: any = [];
	types: any = [];
	producers: any = [];

	typesCopy: any = [];

	checked_plans: any[] = [];
	checked_types: any[] = [];
	checked_producers: any[] = [];

	plans_copy: any;
	search_string: string = '';
	plans_page: number = 1;

    constructor(
        private dialogRef: MatDialogRef<FilterLibraryModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
		private sessionService: SessionService
    ) {}

	calculateOpened() {
		const output = [];

		Utils.rec(this.plans, f => {
			if (f.opened) {
				output.push(f.format_id || f.planogram_id);
			}
		});

		return output;
	}

	rebuildOpened(opened) {
		Utils.rec(this.plans, f => {
			f.opened = opened.includes(f.format_id || f.planogram_id);
		});
	}

	scrollDown() {
		++this.plans_page;
		const opened = this.calculateOpened();

		this.search(this.search_string);
		this.rebuildOpened(opened);
	}

	ngOnInit() {
		this.plans_copy = Utils.deepCopy(this.data.plans);

		this.plans = this.data.plans ?
			this.formatData(Utils.deepCopy(this.data.plans)) : [];
		this.types = this.data.types ?
			this.formatTypes(this.data.types) : [];
		this.producers = this.data.producers ?
			this.formatTypes(this.data.producers, true) : [];
		this.typesCopy = [...this.types];

		this.checked_plans = this.data.checked_plans;
		this.checked_types = this.data.checked_types;
		this.checked_producers = this.data.checked_producers;

		Utils.rec(this.plans, shop => {
			if (this.checked_plans.includes(shop.id || shop.planogram_id)) {
				shop.checked = true;
				Utils.parentCheck(shop);
			} else {
				shop.checked = false;
				Utils.parentCheck(shop);
			}
		});

		Utils.rec(this.types, type => {
			if (this.checked_types.includes(type.name)) {
				type.checked = true;
				Utils.parentCheck(type);
			} else {
				type.checked = false;
				Utils.parentCheck(type);
			}
		});

		Utils.rec(this.producers, type => {
			type.checked = this.checked_producers.includes(type.name);
			if (this.checked_producers.includes(type.name)) {
				Utils.parentCheck(type);
			}
		});
	}

	onNoClick(): void {
		this.dialogRef.close(false);
	}

	cancelFilters(): void {
		this.dialogRef.close(true);
	}

	apply() {
		return this.dialogRef.close({
			plans: this.checked_plans,
			types: this.checked_types,
			producers: this.checked_producers
		});
	}

	formatData(data, slice: boolean = true) {
		const parent: any = {
			id: -1,
			name: 'ALL',
			has_children: true,
			opened: true
		};

		parent.children = data.map(item => {
			item.id = Number(item.format_id);
			item.name = item.format_name;
			item.has_children = item.children.length;
			item.parent = parent;

			if (item.has_children) {
				item.children = item.children.map(i => {
					i.id = Number(i.planogram_id);
					i.name = i.planogram_name;
					i.parent = item;
					i.level = 2;
					return i;
				});
			}
			return item;
		});

		if (parent.children.every(f => !f.has_children)) {
			if (slice) parent.children = parent.children.slice(0, this.plans_page * ITEMS_PER_CHUNK);
		}

		return [parent];
	}

	formatTypes(data, isProducer: boolean = false) {
		const parent: any = {
			id: -1,
			name: 'ALL',
			has_children: true,
			opened: true
		};

		parent.children = data.map(item => {
			item.id = isProducer ? item.id : Number(item.id);
			item.has_children = false;
			item.parent = parent;

			return item;
		});

		return [parent];
	}

	onCheck(element: any, is_types: boolean = false) {
		element.checked = !element.checked;
		Utils.childrenCheck(element);
		Utils.parentCheck(element);

		if (!~element.id && element.checked) {
			if (element.children.some(f => f.has_children)) {
				return Utils.to1DArray(
					element.children.map(format =>
						(format.children || []).length ? format.children.map(ps => ps.id) : format.format_id || format.id
					)
				);
			} else if (!is_types) {
				return Utils.to1DArray(element.children.map(ps => ps.id));
			}

			if (is_types) {
				return this.typesCopy[0].children.map(t => t.name);
			}
		}

		const children = (element.children || []).map(c => c.planogram_id);

		if (!element.parent && !children.length) {
			children.push(element.id || element.format_id || element.planogram_id || element.name);
		}

		if (element.parent) {
			children.push(element.format_id || element.planogram_id || element.name);
		}

		return children.filter(i => i);
	}

	checkPlans(element: any) {
		const children = this.onCheck(element);

		if (element.checked) {
			this.checked_plans = this.checked_plans.concat(children);
		} else {
			this.checked_plans = this.checked_plans.filter(s => !children.includes(s));
		}

		if (!element.checked && element.id == -1) this.checked_plans = [];
	}

	checkTypes(element: any) {
		const children = this.onCheck(element, true);

		if (element.checked) {
			this.checked_types = this.checked_types.concat(children);
		} else {
			this.checked_types = this.checked_types.filter(s => !children.includes(s));
		}

		if (!element.checked && element.id == -1) this.checked_types = [];
	}

	checkProducers(element: any) {
		const children = this.onCheck(element);

		if (element.checked) {
			this.checked_producers = this.checked_producers.concat(children);
		} else {
			this.checked_producers = this.checked_producers.filter(s => !children.includes(s));
		}

		if (!element.checked && element.id == -1) this.checked_producers = [];
	}

	search(search: string) {
		this.search_string = search;
		if (search.length) {
			this.plans = this.findElement(this.formatData(Utils.deepCopy(this.plans_copy), false)[0].children, search);
			Utils.recursiveOpened(this.plans);
			return;
		}
		this.plans = this.formatData(Utils.deepCopy(this.plans_copy), false);

		Utils.rec(this.plans, shop => {
			if (this.checked_plans.includes(shop.id || shop.planogram_id)) {
				shop.checked = true;
				Utils.parentCheck(shop);
			}
		});

		Utils.rec(this.types, type => {
			if (this.checked_types.includes(type.name)) {
				type.checked = true;
				Utils.parentCheck(type);
			}
		});
	}

	searchTypes(search: string, type) {
		if (search.length) {
			const searchResults = this.findElement(this.formatTypes(this.data[type]), search);
			this[type] = searchResults.length ? searchResults[0].children : [];
			Utils.recursiveOpened(this[type]);
			return;
		}
		this[type] = this.formatTypes(this.data[type]);
	}

	findElement(element: any, searchQuery: string) {
		return element.filter(el => {
			if (
				Utils.searchItem(
					el,
					['name', 'format_name'],
					searchQuery,
					this.sessionService.personalSettings.searchAlgorithm
				) && el.id !== -1
			) {
				return el;
			} else if (el.children.some(e =>
				Utils.searchItem(
					e,
					['name'],
					searchQuery,
					this.sessionService.personalSettings.searchAlgorithm
				)
			)) {
				el.children = el.children.filter(e =>
					Utils.searchItem(
						e,
						['name'],
						searchQuery,
						this.sessionService.personalSettings.searchAlgorithm
					)
				);
				return el;
			}
		});
	}
}